var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vh-player",attrs:{"id":_vm.nodeId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }